export const cookies = () =>  {
    const cookies = document.querySelector('.js-cookies-new');
    if (cookies) {
        const cookiesBtn = cookies.querySelector('.cookie-consent__button');

        if (getCookie('agree') != 'true') {
            setTimeout(() => {
                cookies.classList.add('cookie-consent--visible');
            }, 1000);
        }

        cookiesBtn.addEventListener('click', () => {
            cookies.classList.remove('cookie-consent--visible');
            cookies.style.display = 'none';
            document.cookie = 'agree=true';
        });
        function getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }
    }
}